import { toast } from 'react-toastify';

const ToastBody = ({ title, message, textColor }) => (
  <div>
    <h6 className={`${textColor} mb-1`}>{title}</h6>
    <p className="font-size-sm text-dark mb-0">{message}</p>
  </div>
);

export function showSuccessToast(title, message, options = {}) {
  toast.dismiss();
  toast.success(<ToastBody title={title} message={message} textColor="text-success"/>, {
    autoClose: 3000,
    ...options,
  });
}

export function showErrorToast(title, message, options = {}) {
  toast.dismiss();
  toast.error(<ToastBody title={title} message={message} textColor="text-danger" />, {
    autoClose: false,
    ...options,
  });
}

export function showWarningToast(title, message, options = {}) {
  toast.dismiss();
  toast.warn(<ToastBody title={title} message={message} textColor="text-warning" />, {
    autoClose: 5000,
    ...options,
  });
}

export function showInfoToast(title, message, options = {}) {
  toast.dismiss();
  toast.info(<ToastBody title={title} message={message} textColor="text-info" />, {
    autoClose: 3000,
    ...options,
  });
}